module.exports = __webpack_public_path__ + "fonts/Veneer.3fefbe18.woff";